import { getFirebase } from 'firestorter';
import { firestorePaths } from '../../utils/paths';
import BaseDocument from '../../Model/BaseDocument';

class AppCustomization extends BaseDocument {
  constructor(id, opts) {
    super(`${firestorePaths.APP_CUSTOMIZATION}/${id}`, opts);
  }

  get texts() {
    return this.data.texts || {};
  }

  get appIconName() {
    return this.data.appIconName;
  }

  get webAppIconRef() {
    return this.data.webAppIconRef;
  }

  get theme() {
    return this.data.theme || {};
  }

  get baseTheme() {
    return this.theme.baseTheme;
  }

  get primaryColor() {
    return this.theme.colors?.base?.primary || '';
  }

  get welcomeMessage() {
    return this.data.welcomeMessage || '';
  }

  get welcomeMessageAttachments() {
    return this.data.welcomeMessageAttachments || [];
  }

  get coach() {
    return this.data.coach;
  }

  // TODO: Refactor this when we add checkout page customization
  // WARNING: This is a temporary solution to handle checkout page customization for a specific coach.
  get isWorkoutEnabled() {
    return typeof this.data.isWorkoutEnabled === 'boolean' ? this.data.isWorkoutEnabled : true;
  }

  // TODO: Refactor this when we add checkout page customization
  // WARNING: This is a temporary solution to handle the British spelling for a specific coach.
  get useBritishSpelling() {
    return typeof this.data.useBritishSpelling === 'boolean' ? this.data.useBritishSpelling : false;
  }

  async setBaseTheme(baseTheme, lastUpdatedByUserName) {
    return this.updateFields({
      'theme.baseTheme': baseTheme,
      lastUpdatedByUserName,
    });
  }

  async setPrimaryColor(primaryColor, lastUpdatedByUserName) {
    return this.updateFields({
      'theme.colors.base.primary': primaryColor,
      lastUpdatedByUserName,
    });
  }

  async setWelcomeMessage(message) {
    await this.updateFields({
      welcomeMessage: message || getFirebase().firestore.FieldValue.delete(),
    });
  }

  async setWelcomeMessageAttachments(attachments) {
    await this.updateFields({
      welcomeMessageAttachments: attachments || getFirebase().firestore.FieldValue.delete(),
    });
  }

  static getAppCustomizationByCoach = async (coachId) => {
    const appCustomizationDoc = new AppCustomization(coachId);
    await appCustomizationDoc.init();
    return appCustomizationDoc.exists ? appCustomizationDoc : null;
  };
}

export default AppCustomization;
